import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import Cookies from "js-cookie";

export default function Tools() {



  return (
    <div>
      <Header />
<div className='container_roots'>
  <div className='container_size'></div>
</div>
      <Footers />
      <Navbar />
    </div>
  );
}
